import axios from "axios";
import store from "../store";

let config = {
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    baseURL: "",
    // 请求超时时间
    timeout: 10000,
    // 每次请求携带cookie
    withCredentials: true,
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: 'json'
};

const instance = axios.create(config);

// http request 拦截器
instance.interceptors.request.use(
    config => {
        if (store.state.userinfo) { //判断token是否存在
            config.headers.Authorization = store.state.userinfo.token;  //将token设置成请求头
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 自定义接口函数
instance.api = {
    // 获取用户信息
    getUserInfo: function (callback) {
        instance.post("/api/v1/user/getInfo").then((res) => {
            store.commit("userInfo", res.data.data.userinfo);
            window.localStorage.setItem('isLogin', 'true');
            callback(res.data);
        }).catch((error) => {
            store.commit("userInfo", []);
            window.localStorage.setItem('isLogin', 'false');
            callback({"code": 0});
        });
    },
    // 用户登出
    logout: function (callback) {
        instance.post("/api/v1/user/logout").then((res) => {
            store.commit("userInfo", []);
            window.localStorage.setItem('isLogin', 'false');
            callback({"code": 1});
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 创建收藏夹
    favoritesCreate: function (params, callback) {
        instance.post("/api/v1/favorites/create", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 取消收藏
    favoritesCancel: function (params, callback) {
        instance.post("/api/v1/favorites/cancel", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 添加到收藏夹
    favoritesJoin: function (params, callback) {
        instance.post("/api/v1/favorites/join", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 收藏夹重命名
    favoritesRename: function (params, callback) {
        instance.post("/api/v1/favorites/rename", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 收藏夹删除
    favoritesDelete: function (params, callback) {
        instance.post("/api/v1/favorites/delete", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0, 'msg': '请求错误'});
        });
    },
    // 删除收藏夹内的图片
    favoritesDeleteImage: function (params, callback) {
        instance.post("/api/v1/favorites/deleteImage", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0, 'msg': '请求错误'});
        });
    },
    // 移动收藏图片
    favoritesMove: function (params, callback) {
        instance.post("/api/v1/favorites/move", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0, 'msg': '请求错误'});
        });
    },
    // 举报
    report: function (params, callback) {
        instance.post("/api/v1/common/report", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 搜索
    search: function (params, config, callback) {
        instance.post("/api/v1/index/search", params, config).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 获取首页轮播图
    homeAds: function (callback) {
        instance.get("/api/v1/common/getCategoryList?type=homeAds").then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 获取首页热门推荐
    homeRecommend: function (callback) {
        instance.get("/api/v1/index/getRecommend").then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 授权接口
    userGrant: function (params, callback) {
        instance.post("/api/v1/common/userGrant", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
}

export default instance